import type { IProductBundleOption } from "@rogue/universal"
import type { BundleUIOption } from "../RuleTypes"
import type { Product, IRogue, BuyRequest } from "@/js/services/RogueTypes"
import { findBundleProduct } from "@/js/pages/product/rackbuilder/utils/rackbuilder-util"

export function getOptionsForMutantMetalsBundle(rogue: IRogue, rack: Product, bundleOption: IProductBundleOption, options: BundleUIOption[], bundleBuyRequest: BuyRequest): BundleUIOption[] {
  const handleSelection = findBundleProduct(rogue, bundleBuyRequest, 'handle', true)?.name

  return options.filter(opt => {
    if (!handleSelection && opt.label.toLowerCase().includes('flange')) {
      return false
    }

    if (handleSelection?.toLowerCase().includes('hollow') && opt.label.toLowerCase().includes('flange')) {
      return false
    }

    return true
  })
}
